import styled from 'styled-components';

export const CardsWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  padding-left: var(--size-dynamic0130);
  padding-right: var(--size-dynamic0130);
  gap: var(--size-dynamic0100);

  @media (min-width: 960px) {
    height: 390px;
  }

  @media (min-width: 1280px) {
    height: 440px;
  }

  @media (min-width: 1600px) {
    height: 460px;
  }

  @media (min-width: 1920px) {
    height: 550px;
  }

  @media (min-width: 2560px) {
    height: 580px;
  }
`;

export const VerticalAligned = styled.div<{i: number}>`
  position: relative;
  align-self: ${({i}) => (i % 2 === 0 ? 'flex-end' : 'flex-start')};
`;

export const CardContainerDesktop = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  background: linear-gradient(
    to bottom,
    rgba(153, 153, 153, 0.2) 0%,
    rgba(255, 255, 255, 0.2) 100%
  );
  backdrop-filter: blur(30px);
  max-width: 450px;

  @media (min-width: 960px) {
    max-width: 400px;
  }

  @media (min-width: 2560px) {
    max-width: 450px;
  }
`;
